import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    type IconMirroredConstantType,
    type IconColorConstantType,
    type IconDynamicStyleType,
    type IconSizeConstantType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getMirrorStyle,
    isMirroredIcon
} from "../../helpers/direction";

export const getIconSize = ({
    iconSizes,
    size
}: IconSizeConstantType): number => {
    if(typeof size === "number") {
        return size;
    }

    return iconSizes[size];
};

export const getIconColor = ({
    customColor,
    colors,
    color
}: IconColorConstantType): string => {
    if(!customColor) {
        return colors.content.icon[color];
    }

    return colors.project[customColor as keyof NCoreUIKit.ProjectColorPalette] ?? customColor;
};

export const getIconMirrored = ({
    isMirrored,
    icon
}: IconMirroredConstantType): boolean => {
    return isMirrored ?? isMirroredIcon({
        name: icon.displayName
    });
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    isMirrored,
    direction,
    size
}: IconDynamicStyleType) => {
    const styles = {
        container: {
            ...getMirrorStyle({
                isMirrored,
                direction
            }),
            height: size,
            width: size
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
